import { createAction } from '@reduxjs/toolkit';
import type { FileWithPath } from 'react-dropzone';

import { replaceUpperCaseParams } from 'utils/string';
import { getFailurePayload } from 'modules/utils';
import { uploadInOneStep } from 'modules/media/actions';
import { BANNER_MAX_SIZE } from 'modules/entity/subEntities/customize/constants';

import type { UploadSuccessParams } from 'components/customize/components/Uploader';
import type { Template } from './types';
import * as actionTypes from './actionTypes';

export const fetchTemplate = createAction(actionTypes.FETCH_TEMPLATE, () => {
  const { pathname, search } = window.location;
  const params = replaceUpperCaseParams(search);

  return {
    payload: {
      request: {
        method: 'GET',
        url: `/fo${pathname}${params}`,
      },
    },
  };
});

export const fetchTemplateSuccess = createAction(actionTypes.FETCH_TEMPLATE_SUCCESS, (template: Template) => ({
  payload: template,
}));

export const fetchTemplateFailure = createAction(actionTypes.FETCH_TEMPLATE_FAILURE, getFailurePayload);

export const setSelectedTemplate = createAction(actionTypes.SET_SELECTED_TEMPLATE, (id: string) => ({
  payload: { id },
}));

export const uploadBanner = (url: string, image: FileWithPath, onSuccess: (params: UploadSuccessParams) => void) =>
  uploadInOneStep('banner', url, image, onSuccess, { maxSize: BANNER_MAX_SIZE });

export const uploadAdvertising = (url: string, image: FileWithPath, onSuccess: (params: UploadSuccessParams) => void) =>
  uploadInOneStep('advertising', url, image, onSuccess);

export const uploadLogo = (url: string, image: FileWithPath, onSuccess: (params: UploadSuccessParams) => void) =>
  uploadInOneStep('logo', url, image, onSuccess);

export const sendCustomize = createAction(actionTypes.SEND_CUSTOMIZE, (url: string, data: Template) => ({
  payload: {
    request: {
      method: 'POST',
      url,
      data,
    },
    template: data,
  },
}));

export const sendCustomizeSuccess = createAction(actionTypes.SEND_CUSTOMIZE_SUCCESS);

export const sendCustomizeFailure = createAction(actionTypes.SEND_CUSTOMIZE_FAILURE, getFailurePayload);

export const openSaveModal = createAction(actionTypes.OPEN_SAVE_MODAL);

export const closeSaveModal = createAction(actionTypes.CLOSE_SAVE_MODAL);

export const toggleEdit = createAction(actionTypes.TOGGLE_EDIT);
